export default __webpack_public_path__ + "3e52e562642dbbfa7aff0d2adc37bf61.png";